import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const BaseButton = styled(Button)(({}) => ({
    flex: '1',
    margin: '5px 0',
    padding: '12px 25px',
    minHeight: '45px',
    borderRadius: '50px',
    lineHeight: '1.25',
    fontSize: 'inherit',
    textTransform: 'none'
}));

const ThemedButton = styled(BaseButton)(() => ({
}));

const ThemedLinkButton = styled(Button)(({ theme }) => ({
    '&:hover': {
        backgroundColor: 'transparent',
    },
    color: theme.palette.mode === 'dark' && theme.palette.contrastDefault.main
}));

const CheckAvailabilityButton = styled(BaseButton)(({ theme }) => ({
    backgroundColor: theme.palette.tertiary.main,
    color: theme.palette.tertiary.contrastText,
    '&:hover': {
        backgroundColor: theme.palette.tertiary.dark
    }
}));

const WidgetButton = styled(BaseButton)(({ theme }) => ({
    display: 'flex',
    backgroundColor: theme.palette.tertiary.main,
    color: theme.palette.tertiary.contrastText,
    '&:hover': {
        backgroundColor: theme.palette.tertiary.dark,
        color: '#fff'
    }
}));

const MediaButton = styled(BaseButton)(({ theme }) => ({
    padding: '12px 35px',
    fontSize: '.75rem',
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.primary.main : theme.palette.tertiary.main,
    color: theme.palette.mode === 'dark' ? theme.palette.primary.contrastText : theme.palette.tertiary.contrastText,
    '&:hover': {
        backgroundColor: theme.palette.tertiary.dark,
        color: '#fff'
    }
}));

export {
    ThemedButton,
    ThemedLinkButton,
    CheckAvailabilityButton,
    WidgetButton,
    MediaButton
};